import { AppThunk } from '../../../store/rootReducer';
import { isToolActiveSelector } from '../../tool/selectors/tool.selectors';
import { Tool } from '../../tool/utils/tool.utils';
import { trackStopEpisodeMeasurement } from '../../analytics/thunks/track-stop-episode-measurement.thunk';
import { trackStopRuler } from '../../analytics/thunks/track-stop-ruler.thunk';

export const checkToSendUseToolEvent = (): AppThunk => (dispatch, getState) => {
  const isRulerActive = isToolActiveSelector(
    Tool.ruler,
    Tool.rulerAnchored,
  )(getState());
  const isEpisodeMeasurementActive = isToolActiveSelector(
    Tool.episodeMeasurement,
  )(getState());

  if (isRulerActive) {
    dispatch(trackStopRuler('escape'));
  } else if (isEpisodeMeasurementActive) {
    dispatch(trackStopEpisodeMeasurement('escape'));
  }
};
